import { Expose, Type } from 'class-transformer';
import { BaseModel } from '@core/data-access';

export class CpfContributionHistoryModel extends BaseModel {
  @Expose() month!: string;
  @Expose() date!: string;
  @Expose() dateOnly!: string;
  @Expose() amount!: number;
  @Expose() employer!: string;
}

/** Provenance MyInfo answered the group with — echoed back unchanged, never edited. */
export class CpfContributionModel extends BaseModel {
  @Expose()
  classification?: string;

  @Expose()
  @Type(() => CpfContributionHistoryModel)
  history?: CpfContributionHistoryModel[];

  @Expose()
  lastUpdated?: string;

  @Expose()
  lastUpdatedOnly?: string;

  @Expose()
  source?: string;
}
